import { t } from "@/i18n-js/instance";

import { LineItem } from "./LineItem";

interface DueTodayProps {
  dueToday: string;
}

export const DueToday = ({ dueToday }: DueTodayProps) => (
  <LineItem
    description={t("pricing_plans.plan_settings.plan_summary.due_today")}
    value={dueToday}
    descriptionProps={{
      weight: "font-medium",
    }}
    valueProps={{
      weight: "font-medium",
    }}
  />
);
